import { render, staticRenderFns } from "./EmMenuImportModal.vue?vue&type=template&id=0c2376aa&"
import script from "./EmMenuImportModal.vue?vue&type=script&lang=js&"
export * from "./EmMenuImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports